import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, ReactiveFormsModule,Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatTooltip } from '@angular/material/tooltip';
import { Subscription } from 'rxjs';

import { ExportFilesFactory } from '@shared/services/file-export/drivers';
import {
  TFileExportConfiguration,
  TFileExportDriversAvailable,
} from '@shared/services/file-export/file-export-interface';

import { ConfirmationModalComponent } from '../../../../../../routes/components/modals/confirmation-modal/confirmation-modal.component';
import { CommonService } from '@shared/services/common.service';

@Component({
    selector: 'app-text-file-export-modal',
    templateUrl: './text-file-export-modal.component.html',
    styleUrls: ['./text-file-export-modal.component.scss'],
    standalone: true,
    imports: [
      ReactiveFormsModule,
      MatFormField,
      MatInput,
      CdkTextareaAutosize,
      MatIcon,
      MatTooltip,
      MatCheckbox,
      MatButton,
    ],
})

export class TextFileExportModalComponent implements OnInit, OnDestroy {
  @Output() public actionCallback: EventEmitter<TFileExportConfiguration> = new EventEmitter();
  protected readonly ExportFilesFactory = ExportFilesFactory;
  protected isLoading = false;
  private _sub: Subscription | undefined;
  public editForm = this.fb.nonNullable.group({
    text: ['', [Validators.required]],
    pages: this.fb.array([
      ['', [Validators.required]],
    ]),
    options: this.fb.group({
      pageNumber: [true, [Validators.required]],
      headerLogo: [true, [Validators.required]],
      confidentialityClause: [true, [Validators.required]],
      confidentialityClauseText: ['This document is confidential', [Validators.required]],
    }),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { text: string, buttonLabel: string },
    private dialogRef: MatDialogRef<TextFileExportModalComponent>,
    private _commonService: CommonService,
    private fb: FormBuilder,
    private dialog: MatDialog,
  ) {
  }

  get formPages() {
    return this.editForm.get('pages') as FormArray;
  }

  ngOnInit(): void {
    this.formPages.at(0).patchValue(this.data.text);

    this._sub = this._commonService.getIsLoadingObservable().subscribe(state => {
      this.toggleFormDisable(state);
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  addPage(index: number) {
    this.formPages.insert(index, this.fb.control(''));
  }

  removePage(index: number) {
    if (!this.formPages.at(index).value) {
      this.formPages.removeAt(index);
      return;
    }
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: { text: `Are you sure you want to delete page` },
    });
    const dialogSubscription = dialogRef.componentInstance.actionCallback.subscribe(() => {
      this.formPages.removeAt(index);
      dialogRef.close();
      dialogSubscription.unsubscribe();
    });
  }

  confirm(driver: TFileExportDriversAvailable) {
    const data = {
      driver,
      ...this.editForm.value,
    } as TFileExportConfiguration;

    this.actionCallback.emit(data);
  }

  ngOnDestroy() {
    this._sub?.unsubscribe();
  }

  toggleFormDisable(disabled: boolean) {
    this.isLoading = disabled;
    disabled ? this.editForm.disable() : this.editForm.enable();
  }

}
